import { createWebflowBundle } from "../../shared/create-bundle";
import { LandingPage } from "./landing-page";

createWebflowBundle("landing-page", LandingPage, "LandingPage");
